module.exports = __webpack_public_path__ + "static/media/welcome3.dd042550.webp";